import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center">
              <i className="ri-bank-card-line text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">クレカ比較ナビ</span>
          </Link>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-sm text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
              ホーム
            </Link>
            <Link to="/ranking" className="text-sm text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
              ランキング
            </Link>
            <Link to="/comparison" className="text-sm text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
              カード比較
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
